/* istanbul ignore file */
// TODO - Clean Up at implementation
import { useSubnav } from '@ally/next-subnav'
import { useHostServices } from '../../HostServices'

const useCertificateOfDepositSubNav = (isRetirementAccount: boolean): any => {
  const hostServices = useHostServices()

  const orderedSchema = [
    [
      {
        content: 'Renewal Options',
        type: 'link',
        key: 'manage-cds',
        url: '/bank/manage-cds',
      },
    ],
    [
      {
        content: 'Interest Disbursement',
        type: 'link',
        key: 'interest-disbursement',
        url: '/bank/manage-cds/interest-disbursement',
      },
    ],
    [
      {
        content: 'Beneficiaries',
        type: 'link',
        key: 'beneficiaries',
        url: '/beneficiaries/deposit',
      },
    ],
    [
      {
        content: 'Statements and Tax Forms',
        type: 'link',
        key: 'statements-tax-forms',
        url: '/bank/statements-and-forms',
      },
    ],
    [
      {
        content: 'Early Withdrawal',
        type: 'link',
        key: 'early-withdrawal',
        url: '/bank/manage-cds/early-withdrawal',
      },
    ],
  ]

  const iraSchema = [
    [
      {
        content: 'Statements and Tax Forms',
        type: 'link',
        key: 'statements-tax-forms',
        url: '/bank/statements-and-forms',
      },
    ],
    [
      {
        content: 'Request an IRA Distribution',
        type: 'link',
        key: 'ira-request-distribution',
        url: '/bank/manage-ira/request-ira',
      },
    ],
    [
      {
        content: 'Beneficiaries',
        type: 'link',
        key: 'beneficiaries',
        url: '/beneficiaries/ira',
      },
    ],
  ]

  return useSubnav({
    hostServices,
    orderedSchema: isRetirementAccount ? iraSchema : orderedSchema,
  } as any)
}

export default useCertificateOfDepositSubNav
